import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompass = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M18.25 10a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M7.252 9.37c.182-.593.273-.89.437-1.134a2 2 0 0 1 .547-.547c.245-.164.54-.255 1.133-.437L14.25 5.75l-1.502 4.88c-.182.593-.273.89-.437 1.134a2 2 0 0 1-.547.547c-.245.164-.54.255-1.133.437L5.75 14.25l1.502-4.88Z"
		})
	]
});
const ForwardRef = forwardRef(SvgCompass);
export { ForwardRef as ReactComponent };
